import React from 'react'
import ToggleButton from 'modules/react/loan-calculator/content/ToggleButton'
import Spinner from 'modules/react/loan-calculator/content/Spinner'
import { LoanCalculatorContext } from 'modules/react/loan-calculator/LoanCalculatorContainer'

const ToggleInterestType = () => {
  const { interestTypeValue, setInterestTypeValue, productDataObject } = React.useContext(LoanCalculatorContext)
  const { productData, productDataIsLoading } = productDataObject

  if (productDataIsLoading) {
    return <Spinner/>
  }

  return (
    <div className='lc-input-group'>
      <div className='lc-input-group__label'>
        <span className='lc-input-group__label-left'>Rente</span>
        <ToggleButton
          toggleValues={productData?.allowedValues?.InterestType}
          toggleValue={interestTypeValue}
          setToggleValue={setInterestTypeValue}
          labelLeft={productData?.allowedValues?.InterestType[0] === 'Fixed' ? 'Fast rente' : 'Variabel rente'}
          labelRight={productData?.allowedValues?.InterestType[1] === 'Fixed' ? 'Fast rente' : 'Variabel rente'}
        />
      </div>
    </div>
  )
}

export default ToggleInterestType
